import React from 'react'
import H3 from '@material-tailwind/react/Heading3';
import Icon from '@material-tailwind/react/Icon';
import {getUserFromLocalStorage} from "../../helper/helpingFunctions"

export default function ProfileCard(props) {
    let user = getUserFromLocalStorage()
    return (
        <div className="container max-w-7x1 mb-4 px-4 my-5 mx-auto">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-2xl -mt-64">
                    <div className="text-center my-8 card">
                            <H3 color="gray">{user.name}</H3>
                            <div className="mt-0 mb-2 text-gray-700 font-medium flex items-center justify-center gap-2">
                                <Icon name="place" size="xl" />
                                Los Angeles, California
                            </div>
                            
                            <div className="mb-2 text-gray-700 flex items-center justify-center gap-2">
                                <Icon name="account_balance" size="xl" />
                                University of Computer Science
                            </div>
                        </div>
                </div>
        </div>
    )
}
